export default "__VITE_ASSET__DtSnDmWL__"